export const Error404 = () => {
    return (
        <>
            <div className="w-screen h-screen flex justify-center items-center">
                <h1 className="text-8xl">Error 404</h1>

            </div>
        </>
    )
}

export default Error404